import { Icon } from "../../common/components/icons";
import styled from "styled-components";

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 40vh;
`;

export const MessageEmpty = () => (
    <Wrapper>
        <div style={{zoom: 1.5}}>
            <Icon type="alertPage"/>
        </div>
        <div>
            <h1 className="text sizeXl">No hay registros</h1>
            <p className="text sizeSm">Aún no has postulado a ninguna oportunidad. En cuanto lo hagas podrás visualizarlo aquí. </p>
        </div>
    </Wrapper>
)